import {APP_BASE_HREF} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ThemeModule} from '@theme/theme.module';
import {CoreModule} from '@core/core.module';
import {AuthModule} from '@auth/auth.module';
import {StoreModule} from './@store';
import {PagesComponent} from './pages/pages.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {HeaderComponent} from '@theme/components';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {SignaturePadModule} from 'angular2-signaturepad';
import {ChartLibModule} from './chart-lib/chart-lib.module';
import {HttpErrorInterceptor} from '@core/error-handling/http-error.interceptor';
import {UpdatePasswordComponent} from './pages/auth/update-password/update-password.component';
import {ForgotPasswordComponent} from './pages/auth/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './pages/auth/reset-password/reset-password.component';
import {VerifyEmailComponent} from './pages/auth/verify-email/verify-email.component';
import {LoginComponent} from './pages/auth/login-form/login.component';
import {SelectOrganizationComponent} from './pages/auth/select-organization/select-organization.component';
import {RequestCancelInterceptor} from '@core/backend/common/services/request-cancel.interceptor';

const PAGES = [
    DashboardComponent,
    LoginComponent,
    SelectOrganizationComponent,
    UpdatePasswordComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    VerifyEmailComponent,
];

@NgModule({
    declarations: [AppComponent, PagesComponent, HeaderComponent, DashboardComponent, ...PAGES],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        StoreModule.forRoot(),
        ThemeModule.forRoot(),
        AuthModule.forRoot(),
        CoreModule.forRoot(),
        NgxDatatableModule,
        SignaturePadModule,
        ChartLibModule,
        ThemeModule,
    ],
    bootstrap: [AppComponent],
    providers: [
        {provide: APP_BASE_HREF, useValue: '/'},
        {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: RequestCancelInterceptor, multi: true},
    ],
})
export class AppModule {}
